import React from 'react';
import { AppContext } from "../contexts/appContext";

function ProductName() {
  const { activePublisher, publishers } = React.useContext(AppContext);
  const publisherObj = publishers.find(pub => pub.value === activePublisher);
  const productTitle = (publisherObj && publisherObj.engine === 'clickhouse') ? 'Allegro Analytics' : 'Lede Beacon';
  React.useEffect(() => {
    document.title = productTitle;
  }, [productTitle]);
  return (
    <span className="product-name">{productTitle}</span>
  );
}

export default ProductName;